import { cn } from '@/utils/styles';
import { RANK_COLORS, RANK_NAMES } from '@/utils/rankMapping';
import { getFoodImageUrl } from '@/utils/nutrition/getImageUrl';
import { useGetFeaturedFoodV2 } from '@viome/viome-base/src/usecase/Home/HomeQuery';
import { Skeleton } from '@design-system/Skeleton';
import { useNavigate } from 'react-router-dom';
import { EventTracker } from '@/utils';

export const FeatureFoodCard = () => {
  const {
    data: FeaturedFoodData,
    isLoading: isFeaturedFoodLoading,
    isError,
  } = useGetFeaturedFoodV2();
  const navigate = useNavigate();

  const statusColor =
    RANK_COLORS[(FeaturedFoodData?.rank as keyof typeof RANK_COLORS) ?? 1];
  const statusText =
    RANK_NAMES[(FeaturedFoodData?.rank as keyof typeof RANK_NAMES) ?? 1];

  if (isFeaturedFoodLoading) {
    return (
      <div>
        <div className="relative w-96 h-32 rounded-sm p-4 border border-[rgb(255,255,255,0.1)] bg-[rgba(91,92,100,0.3)] backdrop-blur-3xl overflow-hidden">
          <div className="flex justify-between">
            <div className="flex flex-col gap-2">
              <Skeleton className="w-32 h-2 animate-pulse bg-gray-600 rounded-sm mb-4" />
              <Skeleton className="w-24 h-4 animate-pulse bg-gray-600 rounded-sm" />
              <Skeleton className="w-14 h-4 animate-pulse bg-gray-600 rounded-sm" />
            </div>
            <Skeleton className="w-28 h-24 animate-pulse bg-gray-600 rounded-sm" />
          </div>
        </div>
      </div>
    );
  }

  if (isError || !FeaturedFoodData) {
    return;
  }

  return (
    <>
      <div
        className={cn(
          'relative w-96 h-32 cursor-pointer',
          'rounded-sm',
          'p-4',
          'overflow-hidden',
          'before:absolute',
          'before:inset-0',
          'before:pointer-events-none',
        )}
        style={{
          background: 'var(--surface-blur-mid-50, #FFFFFF80)',
          backdropFilter: 'blur(50px)',
          boxShadow:
            '0px 1px 0px 0px #FFFFFF0A inset, 0px 1px 3px 0px #0000001A',
        }}
        onClick={() => {
          EventTracker.trackEvent('home', 'home_featured_food');
          navigate(`/nutrition/foods/${FeaturedFoodData?.id}`);
        }}
      >
        <div className="flex justify-between">
          <div className="flex flex-col">
            <p className="typography-caption2 text-tertiary mb-4">
              Featured Food
            </p>

            <h2 className="typography-h2 text-primary mb-1">
              {FeaturedFoodData?.title}
            </h2>

            <div className="flex flex-col justify-start">
              <div className="flex items-center gap-2">
                <div
                  className="w-2 h-2 rounded-full"
                  style={{ backgroundColor: statusColor }}
                />
                <span
                  className="typography-caption1"
                  style={{ color: statusColor }}
                >
                  {statusText}
                </span>
              </div>
            </div>
          </div>
          {FeaturedFoodData?.image_url && (
            <img
              src={getFoodImageUrl(FeaturedFoodData?.image_url)}
              alt={FeaturedFoodData.title}
              className="w-28 h-24 object-cover"
            />
          )}
        </div>
      </div>
    </>
  );
};
